export const HomepageSurveyLastSeenAtLocalStorageKey = "homepage_survey_last_seen_at";

export const HomepageImpressionCount = "homepage_impression_count";

export const HomepageTypeformId = "MuhB6N5v";
